import * as routes from "../../constants/routes";
import ActionButton from "../ActionButton";
import ErrorBoundary from "../ErrorBoundary";
import Footer from "../Footer";
import Header from "../Header";
import React, {useEffect} from "react";
import SetNoIndex from "../../lib/SetNoIndex";
import styles from "./TimeoutPage.module.css";
import usePageView from "../../lib/usePageView";
import {Container, Row, Column} from "../grid";
import {RouteComponentProps} from "react-router-dom";
import {StaticContext} from "react-router";

const strings = {
    title: "1st Financial Bank USA Card Request Canceled",
    header: "Application Time Out",
    subtitle: "For your security",
    description: "Your application has been canceled and will not be processed.",
    startNew: "Start a New Application",
};

type RouterState = {
    to?: string;
    description?: string;
    noLink?: boolean;
};

export default function TimeoutPage(
    props: RouteComponentProps<undefined, StaticContext, RouterState>,
) {
    useEffect(() => {
        document.title = strings.title;
    }, []);

    SetNoIndex();
    usePageView(strings.title);

    let description: string | undefined = undefined;
    if (props.location?.state?.description) {
        description = props.location.state.description;
    }

    let newLinkTo = routes.ORGANIC_APP;
    if (props.location?.state?.to) {
        newLinkTo = props.location.state.to;
    }

    return (
        <ErrorBoundary>
            <Header />
            <Container className={styles.container}>
                <Row>
                    <Column>
                        <div className={styles.title}>{strings.header}</div>
                    </Column>
                </Row>
                <Row>
                    <Column>
                        <div className={styles.subtitle}>{strings.subtitle}</div>
                    </Column>
                </Row>
                <Row>
                    <Column>
                        <div className={styles.description}>
                            {description ? description : strings.description}
                        </div>
                    </Column>
                </Row>
                {!props.location?.state?.noLink ? (
                    <Row>
                        <Column>
                            <ActionButton
                                label={strings.startNew}
                                linkTo={newLinkTo}
                                openInSameTab={true}
                                search={window.location.search}
                            />
                        </Column>
                    </Row>
                ) : null}
            </Container>
            <Footer />
        </ErrorBoundary>
    );
}
